import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";

import {
  adminGenerateSampleMatchesFormSchema,
  AdminGenerateSampleMatchesFormSchema,
} from "./schema";

export const AdminGenerateSampleMatchesForm = ({
  onSubmit,
  defaultValues = {
    jobTitle: "",
    jobDescription: "",
  },
  disabled = false,
}: {
  onSubmit: (data: AdminGenerateSampleMatchesFormSchema) => void;
  defaultValues?: AdminGenerateSampleMatchesFormSchema;
  disabled?: boolean;
}) => {
  const form = useForm<AdminGenerateSampleMatchesFormSchema>({
    resolver: zodResolver(adminGenerateSampleMatchesFormSchema),
    mode: "onChange",
    defaultValues,
  });
  return (
    <Form {...form}>
      <form
        className="w-full flex flex-col gap-4"
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <FormField
          control={form.control}
          name="jobTitle"
          render={({ field }) => (
            <FormItem>
              <FormLabel required>Title</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  placeholder="fCFO"
                  minLength={1}
                  disabled={disabled}
                  aria-disabled={disabled}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="jobDescription"
          render={({ field }) => (
            <FormItem>
              <FormLabel required>Job Description</FormLabel>
              <FormControl>
                <Textarea
                  {...field}
                  placeholder="Support the team in building and monitoring financial controls, revenue projections, ..."
                  minLength={1}
                  disabled={disabled}
                  aria-disabled={disabled}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="!mb-1 flex justify-between">
          <Button
            variant="secondary"
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={() => form.handleSubmit(onSubmit)()}
          >
            Generate Sample Matches
          </Button>
        </div>
      </form>
    </Form>
  );
};
